import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const ProductModalProductDetailsSupplierFragmentDoc = gql`
  fragment ProductModalProductDetailsSupplier on Supplier {
    id
    name
  }
` as unknown as DocumentNode<Types.ProductModalProductDetailsSupplierFragment, unknown>
